import {
    ShieldCheck,
    Banknote,
    FileCheck2,
    Globe,
    Lock,
    Building2,
} from "lucide-react";

const ITEMS = [
    {
        icon: Banknote,
        title: "RBI-Aligned Architecture",
        desc: "PA-CB framework, AD-I bank partnerships and Schedule III ready reporting.",
    },
    {
        icon: Globe,
        title: "SWIFT Enabled",
        desc: "Direct SWIFT gpi tracking with MT103 receipts on every outward payment.",
    },
    {
        icon: FileCheck2,
        title: "EDPMS + IDPMS Integration",
        desc: "Automatic invoice filing and closure with both reporting systems.",
    },
    {
        icon: Lock,
        title: "End-to-End Encryption",
        desc: "TLS 1.3 in transit. AES-256 at rest. SOC 2 controls in place.",
    },
    {
        icon: ShieldCheck,
        title: "Audit-Ready Infrastructure",
        desc: "Full event log with immutable trails and exportable audit reports.",
    },
    {
        icon: Building2,
        title: "Partner Bank Network",
        desc: "Local AD-I rails for INR and global correspondent network for FX.",
    },
];

const BADGES = [
    "RBI PA-CB Framework",
    "SWIFT gpi",
    "EDPMS",
    "IDPMS",
    "AD-I Banks",
    "SOC 2 Controls",
    "ISO 27001 Aligned",
    "AES-256",
];

export default function Compliance() {
    return (
        <section
            id="compliance"
            data-testid="compliance-section"
            className="bg-zinc-50 py-24 md:py-32 px-4 md:px-8 overflow-hidden"
        >
            <div className="mx-auto max-w-7xl">
                <div className="max-w-2xl">
                    <span className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-700">
                        Compliance & trust
                    </span>
                    <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-zinc-950">
                        Built like an institution. Operated like a product.
                    </h2>
                </div>

                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                    {ITEMS.map((it) => (
                        <article
                            key={it.title}
                            className="rounded-2xl border border-zinc-200 bg-white p-6 sm:p-7 hover:border-emerald-300 transition-colors"
                        >
                            <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-600 text-white">
                                <it.icon className="h-5 w-5" />
                            </span>
                            <h3 className="font-heading mt-5 text-lg font-bold tracking-tight text-zinc-950">
                                {it.title}
                            </h3>
                            <p className="mt-2 text-sm text-zinc-600 leading-relaxed">
                                {it.desc}
                            </p>
                        </article>
                    ))}
                </div>

                {/* Badge marquee */}
                <div className="mt-12 rounded-2xl border border-zinc-200 bg-white py-5 overflow-hidden">
                    <div className="flex marquee-track gap-10 whitespace-nowrap">
                        {[...BADGES, ...BADGES].map((b, i) => (
                            <span
                                key={`${b}-${i}`}
                                className="inline-flex items-center gap-2 px-4 text-sm font-bold tracking-wider uppercase text-zinc-600"
                            >
                                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                                {b}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
